package org.example.site_web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOut
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.topBottom
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.images.LinkedInIcon
import org.example.site_web.components.widgets.ImageFusionViewer
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

//TODO on peut faire mieux
fun getConsecutiveNumbers(current:Int, max : Int): Pair<Int,Int>{
    //console.log(Pair(1+(current%max), 1+((1+(current%max))%max)))
    return Pair(1+(current%max), 1+((1+(current%max))%max))

}

@Composable
fun LinkedInBloc() {
    Box() {
        var colorLnd by remember { mutableStateOf(Colors.White) }
        Row(
            Modifier.margin(top=0.5.em)
                .color(Colors.White), verticalAlignment = Alignment.CenterVertically) {
            A(href = "https://www.linkedin.com/company/accelarge-innovations/") {
                Box(
                    Modifier.padding(left = 0.cssRem, right = 2.0.cssRem)
                        .onMouseOver { colorLnd = aiPalette.mainPalette.darker as Color.Rgb }
                        .onMouseOut { colorLnd = Colors.White })
                {

                    LinkedInIcon(Modifier
                        .height(2.cssRem)
                        .width(2.cssRem),
                        color = colorLnd)
                }
            }
        }
    }
}

@Composable
fun WhoAreWe() {
    Box(
        Modifier
            .fillMaxWidth()
            .background(Colors.Black)
            .padding(top=1.em,bottom = 2.em), contentAlignment = Alignment.Center
    ) {
        Column(
            Modifier.width(min(80.vw, 1536.px))
                .padding {
                    topBottom(1.em)
                }, horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            Span(
                Modifier.fontSize(1.2.cssRem)
                    .margin(bottom=1.em)
                    .fontWeight(FontWeight.SemiBold).toAttrs()
            )
            {
                AccTriangleIcon(Modifier.attr("fill","white"))
                Text("A propos d'Accelarge Innovations ")
                Span(Modifier.minWidth(2.em).toAttrs())
            }


            Row(Modifier
                .displayIfAtLeast(Breakpoint.LG)
                .fillMaxWidth(),
                verticalAlignment = Alignment.Top,
                horizontalArrangement = Arrangement.SpaceBetween)
            {
                OurSociety(Modifier.maxWidth(25.cssRem))
                OurSupports(Modifier.maxWidth(25.cssRem))
                ImageFusionViewer(Modifier.displayIfAtLeast(Breakpoint.XL))
            }
            Column(Modifier
                .displayUntil(Breakpoint.LG)
                .fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center)
            {
                OurSociety(Modifier
                    .fillMaxWidth()
                    .margin(bottom = 1.cssRem))
                OurSupports(Modifier
                    .fillMaxWidth())
            }
        }
    }
}

@Composable
fun OurSociety(modifier:Modifier=Modifier) {
        Column(modifier,
            horizontalAlignment = Alignment.Start) {
            Span(
                Modifier
                    .whiteSpace(WhiteSpace.PreWrap)
                    .fontSize(0.7.em).toAttrs()
            ) {
                Text(
                    "Nous sommes une société d'ingénierie créée\u00a0en\u00a02025 et implantée dans le Pays de Lorient en Bretagne.\r\n\r\n" +
                            "Dirigée par un ingénieur généraliste possédant plus de 18\u00a0"+
                            "années d'expérience dans l'industrie et la R&D nos objectifs sont de "+
                            "mettre la passion du métier au service des entreprises qui souhaitent progresser."
                )
            }
            LinkedInBloc()
        }
}

@Composable
fun OurSupports(modifier:Modifier=Modifier){
        Column(modifier) {
            Span(Modifier
                .whiteSpace(WhiteSpace.PreWrap)
                .fontSize(0.7.em).toAttrs()) {
                Text("Accelarge Innovations est soutenu par l'incubateur Emergys au sein de la Technopole de Lorient.\r\n\r\n")
            }
            Span(Modifier
                .whiteSpace(WhiteSpace.PreWrap)
                .fontSize(0.7.em).toAttrs()) {
                Text("En portant le projet Ind&ffi - Nous souhaitons mettre la technologie au service des travailleurs indépendants pour renforcer leur efficacité.\r\n\r\n")
            }
            Row(Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceAround) {
                Img(src = "/assets/pics/oursupports/technopole.svg",
                    attrs=Modifier.height(4.em).toAttrs())
                Img(src = "/assets/pics/oursupports/logo_bzh_acc.png",
                    attrs=Modifier.height(4.em).toAttrs())
            }
        }
}
